// <s-responsive-details> renders closed by default and opens its child <details> from the given breakpoint up (desktop shows the
// content as a plain list) and collapsed below it, where the summary works as an accordion toggle.
class SResponsiveDetails extends HTMLElement {
  #query;
  #sync = () => {
    const details = this.querySelector(':scope > details');
    if (details) details.open = this.#query.matches;
  };

  connectedCallback() {
    this.#query = window.matchMedia(this.dataset.media || '(min-width: 768px)');
    this.#sync();
    this.#query.addEventListener('change', this.#sync);
  }

  disconnectedCallback() {
    this.#query?.removeEventListener('change', this.#sync);
  }
}

if (!customElements.get('s-responsive-details')) customElements.define('s-responsive-details', SResponsiveDetails);
